
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("72ggt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $130ddf635191ef41$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useIssueCreateWithFieldPrefilling", () => $130ddf635191ef41$export$ed5d3f997a26357b);
$parcel$export(module.exports, "useIssueCreateModalWithPrefillingForIssueCreateEmbed", () => $130ddf635191ef41$export$8f837c39a3be9608);

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $12DRg = parcelRequire("12DRg");

var $jFHCE = parcelRequire("jFHCE");

var $eSnSE = parcelRequire("eSnSE");

var $ixiAQ = parcelRequire("ixiAQ");

var $iIqFO = parcelRequire("iIqFO");

var $jipjz = parcelRequire("jipjz");

var $dRfS0 = parcelRequire("dRfS0");

var $eJrcF = parcelRequire("eJrcF");

var $kbiA6 = parcelRequire("kbiA6");

var $9LtGB = parcelRequire("9LtGB");

var $jHGDp = parcelRequire("jHGDp");
const $130ddf635191ef41$var$NewIssueCreateTrigger = ()=>{
    const { data: data } = (0, $eJrcF.useResource)((0, $dRfS0.gicOptInStatusResources));
    const subscriptionHandle = (0, $eJOHy.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const currentIssueCreateVisibility = data?.gicOptInStatus;
    const getDefaultValues = (0, $kbiA6.usePrefilledDefaultValues)();
    const openIssueCreateDialogHandler = (0, $eJOHy.useCallback)(// @ts-expect-error - TS7006 - Parameter '_payload' implicitly has an 'any' type.
    async (event, _payload)=>{
        let payload;
        if (event instanceof CustomEvent && !_payload) payload = event.detail;
        else payload = _payload;
        const actualPayload = payload?.payload;
        const triggerPointKey = payload?.triggerPointKey;
        const isPrefillingAllowed = !!actualPayload?.isPrefillingAllowed;
        const triggerPointKeySuffix = actualPayload ? actualPayload.triggerPointKeySuffix : '';
        const callback = actualPayload?.callback;
        const title = actualPayload?.title;
        // EXAMPLE of payload not to be transformed
        // {
        //     shouldNotTransform: true,
        //     payload: {
        //         customFieldsToPreserveOnFormRecreation: ['issuelinks'],
        //         defaultValues: {
        //             issueLinks: {
        //                 linkedIssueKeys: ['IC-31'],
        //             },
        //         },
        //     },
        // },
        const extractedPayload = actualPayload?.target ? (0, $9LtGB.extractEventAttributes)(actualPayload.target) : actualPayload;
        let createModalPayload = null;
        if (isPrefillingAllowed) {
            (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).start();
            const { defaultValues: defaultValuesFromAPI, issueType: issueType, projectId: projectId, requestType: requestType } = await getDefaultValues({
                prefilledFieldsData: {
                    ...actualPayload?.prefilledFields
                },
                callContextAPI: true
            });
            extractedPayload.prefilledFields = {
                ...extractedPayload.prefilledFields,
                pid: projectId,
                issuetype: issueType,
                requestype: requestType
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(extractedPayload)) createModalPayload = (0, $9LtGB.transformGICPayload)(extractedPayload, isPrefillingAllowed);
            const mergedDefaultValues = (0, $9LtGB.mergeDefaultValues)(defaultValuesFromAPI, createModalPayload?.defaultValues);
            if (createModalPayload) createModalPayload.defaultValues = mergedDefaultValues;
            const prefilledCustomFields = (0, $9LtGB.filterCustomFields)(extractedPayload);
            (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).success();
            const constructedTriggerPointKey = triggerPointKeySuffix ? `prefilled-issue-create-${triggerPointKeySuffix}` : 'prefilled-issue-create';
            openIssueCreateModal({
                ...(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(payload, [
                    'shouldNotTransform'
                ]),
                payload: createModalPayload,
                // Will fix the trigger point name once approach is finalised
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerPointKey: constructedTriggerPointKey,
                prefilledCustomFields: prefilledCustomFields,
                ecosystemCallback: {
                    callbackFunction: callback
                },
                ...title && {
                    title: title
                }
            });
        } else if (currentIssueCreateVisibility !== null) {
            if (currentIssueCreateVisibility?.isEnabled) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(extractedPayload)) {
                    if (payload?.shouldNotTransform === true) createModalPayload = extractedPayload;
                    else createModalPayload = (0, $9LtGB.transformGICPayload)(extractedPayload);
                }
                openIssueCreateModal({
                    ...(0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(payload, [
                        'shouldNotTransform'
                    ]),
                    payload: createModalPayload,
                    triggerPointKey: triggerPointKey
                });
            } else (0, $ixiAQ.default)((0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(payload, [
                'shouldNotTransform'
            ]));
        } else (0, $eSnSE.default).safeErrorWithoutCustomerData('new-issue-create-trigger', 'visibility data is still getting downloaded');
    }, [
        currentIssueCreateVisibility,
        getDefaultValues,
        openIssueCreateModal
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (currentIssueCreateVisibility !== null) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.IssueCreate = window.IssueCreate || {};
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.IssueCreate.Visibility = currentIssueCreateVisibility; // For monolith to consume the same
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.JIRA = window.JIRA || {};
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.JIRA.Forms = {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ...window.JIRA.Forms,
                modernIssueCreate: (0, $jHGDp.modernIssueCreateInGenericFunctions)
            };
        }
    }, [
        currentIssueCreateVisibility
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // @ts-expect-error - TS2769 - No overload matches this call.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('openIssueCreateDialog', openIssueCreateDialogHandler);
        subscriptionHandle.current = ()=>// @ts-expect-error - TS2769 - No overload matches this call.
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('openIssueCreateDialog', openIssueCreateDialogHandler);
        return ()=>{
            subscriptionHandle.current();
            subscriptionHandle.current = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
        };
    }, [
        openIssueCreateDialogHandler,
        subscriptionHandle
    ]);
    return null;
};
var $130ddf635191ef41$export$2e2bcd8739ae039 = $130ddf635191ef41$var$NewIssueCreateTrigger;
const $130ddf635191ef41$export$ed5d3f997a26357b = ()=>{
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $jipjz.useTriggerIssueCreateModal)();
    const getDefaultValues = (0, $kbiA6.usePrefilledDefaultValues)();
    const openIssueCreateModalHandler = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (triggerPointKey, fields, callback)=>{
        (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).start();
        let fieldList = fields;
        const { defaultValues: defaultValuesFromAPI, issueType: issueType, projectId: projectId, requestType: requestType } = await getDefaultValues({
            prefilledFieldsData: fieldList
        });
        fieldList = {
            ...fieldList,
            pid: projectId,
            issuetype: issueType,
            requestype: requestType
        };
        let payload = null;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(fieldList)) payload = (0, $9LtGB.transformGICPayload)({
            prefilledFields: fieldList
        }, true);
        if (payload) payload.defaultValues = (0, $9LtGB.mergeDefaultValues)(defaultValuesFromAPI, payload?.defaultValues);
        const prefilledCustomFields = (0, $9LtGB.filterCustomFields)({
            prefilledFields: fieldList
        });
        (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).success();
        openIssueCreateModal({
            payload: payload,
            triggerPointKey: // @ts-expect-error string is of type trigger point key, not adding this type as they are not decided yet
            triggerPointKey,
            prefilledCustomFields: prefilledCustomFields,
            ecosystemCallback: {
                callbackFunction: callback
            }
        });
    }, [
        openIssueCreateModal,
        getDefaultValues
    ]);
    return openIssueCreateModalHandler;
};
const $130ddf635191ef41$export$8f837c39a3be9608 = ()=>{
    const getDefaultValues = (0, $kbiA6.usePrefilledDefaultValues)();
    const getPrefilledIssueCreateProps = (0, $eJOHy.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async (fields, callback)=>{
        (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).start();
        let fieldList = fields;
        const { defaultValues: defaultValuesFromAPI, issueType: issueType, projectId: projectId, requestType: requestType } = await getDefaultValues({
            prefilledFieldsData: fieldList,
            callContextAPI: true
        });
        fieldList = {
            ...fieldList,
            pid: projectId,
            issuetype: issueType,
            requestype: requestType
        };
        let payload = null;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(fieldList)) payload = (0, $9LtGB.transformGICPayload)({
            prefilledFields: fieldList
        }, true);
        if (payload) payload.defaultValues = (0, $9LtGB.mergeDefaultValues)(defaultValuesFromAPI, payload?.defaultValues);
        const prefilledCustomFields = (0, $9LtGB.filterCustomFields)({
            prefilledFields: fieldList
        });
        (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).success();
        return {
            issueCreatePayload: payload,
            prefilledCustomFields: prefilledCustomFields,
            ecosystemCallback: callback ? {
                callbackFunction: callback
            } : undefined
        };
    }, [
        getDefaultValues
    ]);
    return getPrefilledIssueCreateProps;
};

});
parcelRegister("kbiA6", function(module, exports) {

$parcel$export(module.exports, "usePrefilledDefaultValues", () => $58e4d4c9a6562c5d$export$38f7ab2f4d0821a4);

var $eJOHy = parcelRequire("eJOHy");

var $7jTnu = parcelRequire("7jTnu");

var $eDBhy = parcelRequire("eDBhy");

var $jGzN3 = parcelRequire("jGzN3");

var $lRq8t = parcelRequire("lRq8t");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $iIqFO = parcelRequire("iIqFO");

var $kMZx3 = parcelRequire("kMZx3");
const $58e4d4c9a6562c5d$var$ECOSYSTEM_API_PREFILL_DEFAULT_VALUES_API = '/rest/internal/latest/ecosystem/issue/fields';
const $58e4d4c9a6562c5d$var$ECOSYSTEM_API_PREFILL_CONTEXT_FIELDS_API = '/rest/internal/latest/ecosystem/issue/context';
const $58e4d4c9a6562c5d$var$ERROR_MESSAGE_ID = (0, $hrodw.toFlagId)('IssueCreatePrefillFailed');
const $58e4d4c9a6562c5d$var$isObject = (value)=>{
    return value !== null && typeof value === 'object' && !Array.isArray(value);
};
const $58e4d4c9a6562c5d$export$93b4eaa50e476277 = (prefilledFieldsData)=>{
    const modifiedPrefilledFieldsData = {
        fieldsInput: []
    };
    if ($58e4d4c9a6562c5d$var$isObject(prefilledFieldsData)) Object.keys(prefilledFieldsData).forEach((key)=>{
        const data = prefilledFieldsData[key];
        if (Array.isArray(data)) {
            const modifiedData = [];
            for (const value of data)if (typeof value === 'number' || typeof value === 'string') modifiedData.push(value.toString());
            modifiedPrefilledFieldsData.fieldsInput.push({
                fieldId: key,
                values: modifiedData
            });
        } else if (typeof data === 'number' || typeof data === 'string') modifiedPrefilledFieldsData.fieldsInput.push({
            fieldId: key,
            values: [
                data.toString()
            ]
        });
    });
    return modifiedPrefilledFieldsData;
};
const $58e4d4c9a6562c5d$export$fb9547a2d8fedba1 = (modifiedPrefilledFieldsData)=>{
    const options = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify(modifiedPrefilledFieldsData)
    };
    return options;
};
const $58e4d4c9a6562c5d$export$109987e4e4835e7a = (modifiedPrefilledFieldsData, prefilledFieldsData)=>{
    const issueTypeProvided = $58e4d4c9a6562c5d$var$transformInputValueToNumber(prefilledFieldsData?.issuetype)?.toString();
    const projectIdProvided = $58e4d4c9a6562c5d$var$transformInputValueToNumber(prefilledFieldsData?.pid)?.toString();
    const requestData = {
        fields: modifiedPrefilledFieldsData,
        projectId: projectIdProvided,
        issueTypeId: issueTypeProvided
    };
    const options = {
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify(requestData)
    };
    return options;
};
const $58e4d4c9a6562c5d$var$transformInputValueToNumber = (value)=>{
    let transformedValue = value;
    if (Array.isArray(value)) transformedValue = value[0];
    if ((typeof transformedValue === 'string' || typeof transformedValue === 'number') && Number(transformedValue)) return Number(transformedValue);
    return null;
};
const $58e4d4c9a6562c5d$export$38f7ab2f4d0821a4 = ()=>{
    const { showFlag: showFlag } = (0, $bILK0.useFlagService)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const getDefaultValues = (0, $eJOHy.useCallback)(({ prefilledFieldsData: prefilledFieldsData, callContextAPI: callContextAPI = false })=>{
        const modifiedPrefilledFieldsData = $58e4d4c9a6562c5d$export$93b4eaa50e476277(prefilledFieldsData);
        const fetchContextFieldsData = async ()=>{
            try {
                const inputOptions = $58e4d4c9a6562c5d$export$109987e4e4835e7a(modifiedPrefilledFieldsData, prefilledFieldsData);
                const contextFields = await (0, $jGzN3.performPostRequest)(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                `${window.location.origin}${$58e4d4c9a6562c5d$var$ECOSYSTEM_API_PREFILL_CONTEXT_FIELDS_API}`, inputOptions);
                return contextFields;
            } catch (error) {
                (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).failure();
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'fetchEcosystemContextFieldsData',
                        packageName: 'jiraNewIssueCreateTrigger',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                showFlag({
                    key: $58e4d4c9a6562c5d$var$ERROR_MESSAGE_ID,
                    type: 'error',
                    title: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $kMZx3.default).errorMessageTitleNonFinalIssueTerminologyRefreshM4 : (0, $kMZx3.default).errorMessageTitleNonFinal),
                    description: formatMessage((0, $kMZx3.default).errorMessageDescriptionNonFinal),
                    messageId: 'new-issue-create-trigger.use-prefilled-default-values.show-flag.error.fetch-context-fields-data.show-flag.error',
                    messageType: 'transactional'
                });
            }
        };
        const fetchPrefilledDefaultValues = async ()=>{
            const inputOptions = $58e4d4c9a6562c5d$export$fb9547a2d8fedba1(modifiedPrefilledFieldsData);
            try {
                const defaultValues = await (0, $jGzN3.performPostRequest)($58e4d4c9a6562c5d$var$ECOSYSTEM_API_PREFILL_DEFAULT_VALUES_API, inputOptions);
                return defaultValues;
            } catch (error) {
                (0, $iIqFO.EcosystemAPIPrefillingUFOExperience).failure();
                (0, $eDBhy.fireIssueCreateErrorAnalytics)({
                    meta: {
                        id: 'ecosystemAPIPrefillDefaultValues',
                        packageName: 'jiraNewIssueCreateTrigger',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                showFlag({
                    key: $58e4d4c9a6562c5d$var$ERROR_MESSAGE_ID,
                    type: 'error',
                    title: formatMessage((0, $7jTnu.fg)('jira-issue-terminology-update-m4') ? (0, $kMZx3.default).errorMessageTitleNonFinalIssueTerminologyRefreshM4 : (0, $kMZx3.default).errorMessageTitleNonFinal),
                    description: formatMessage((0, $kMZx3.default).errorMessageDescriptionNonFinal),
                    messageId: 'new-issue-create-trigger.use-prefilled-default-values.show-flag.error.fetch-prefilled-default-values.show-flag.error',
                    messageType: 'transactional'
                });
            }
        };
        const getPrefilledData = async ()=>{
            if (!callContextAPI) {
                const defaultValues = await fetchPrefilledDefaultValues();
                const issueType = $58e4d4c9a6562c5d$var$transformInputValueToNumber(prefilledFieldsData?.issuetype);
                const projectId = $58e4d4c9a6562c5d$var$transformInputValueToNumber(prefilledFieldsData?.pid);
                const requestType = prefilledFieldsData?.requestType;
                return {
                    defaultValues: defaultValues,
                    issueType: issueType,
                    projectId: projectId,
                    requestType: requestType
                };
            }
            const [defaultValues, contextFieldsData] = await Promise.all([
                fetchPrefilledDefaultValues(),
                fetchContextFieldsData()
            ]);
            const issueType = contextFieldsData?.issueType?.issueTypeId;
            const projectId = contextFieldsData?.project?.projectId;
            const requestType = contextFieldsData?.requestType?.key;
            return {
                defaultValues: defaultValues,
                issueType: issueType,
                projectId: projectId,
                requestType: requestType
            };
        };
        return getPrefilledData();
    }, [
        formatMessage,
        showFlag
    ]);
    return getDefaultValues;
};

});
parcelRegister("eDBhy", function(module, exports) {

$parcel$export(module.exports, "fireIssueCreateErrorAnalytics", () => $7521412fa2e04cd6$export$fffbd8c0e67dbb84);

var $eezJL = parcelRequire("eezJL");

var $gYnSx = parcelRequire("gYnSx");

var $7jTnu = parcelRequire("7jTnu");

var $bguQO = parcelRequire("bguQO");

var $dqT1s = parcelRequire("dqT1s");
const $7521412fa2e04cd6$export$fffbd8c0e67dbb84 = (payload)=>{
    if (!(0, $7jTnu.fg)('issue-create-fire-error-analytics-refactor')) return (0, $gYnSx.default)(payload);
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $bguQO.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...error && (0, $eezJL.isApolloError)(error) ? {
                errorType: (0, $dqT1s.handleApolloError)(error)
            } : {}
        },
        error: error
    });
};

});
parcelRegister("dqT1s", function(module, exports) {

$parcel$export(module.exports, "handleApolloError", () => $66011c8af62c00c5$export$31b755cdc25616f2);
const $66011c8af62c00c5$export$31b755cdc25616f2 = (error)=>{
    let errorType = 'unknown';
    if (error.networkError != null) errorType = 'networkError';
    else if (error.graphQLErrors && error.graphQLErrors.length > 0) errorType = 'graphQLError';
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ErrorType'.
    return errorType;
};

});


parcelRegister("kMZx3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bd3430eb5f22960$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9bd3430eb5f22960$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    errorMessageTitleNonFinal: {
        "id": "new-issue-create-trigger.use-prefilled-default-values.error-message-title-non-final",
        "defaultMessage": "We weren't able to open the issue create modal!"
    },
    errorMessageDescriptionNonFinal: {
        "id": "new-issue-create-trigger.use-prefilled-default-values.error-message-description-non-final",
        "defaultMessage": "Please try again or contact your administrator if the problem persists."
    },
    errorMessageTitleNonFinalIssueTerminologyRefreshM4: {
        "id": "new-issue-create-trigger.use-prefilled-default-values.error-message-title-non-final-issue-terminology-refresh-m4",
        "defaultMessage": "We weren't able to open the work item create modal"
    }
});

});


parcelRegister("9LtGB", function(module, exports) {

$parcel$export(module.exports, "generateDefaultValues", () => $4964d6f513930168$export$300f392f5922240);
$parcel$export(module.exports, "extractEventAttributes", () => $4964d6f513930168$export$1e69307ca1d0a0a);
$parcel$export(module.exports, "filterCustomFields", () => $4964d6f513930168$export$3d0318b836ef9005);
$parcel$export(module.exports, "mergeDefaultValues", () => $4964d6f513930168$export$2b461e4b4c8d36cf);
$parcel$export(module.exports, "transformGICPayload", () => $4964d6f513930168$export$db3a4d24608ba186);
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $8dH3d = parcelRequire("8dH3d");

var $3Q6BV = parcelRequire("3Q6BV");

var $fRoGq = parcelRequire("fRoGq");

var $eGXjT = parcelRequire("eGXjT");
const $4964d6f513930168$var$CUSTOM_FIELD_PREFIX = 'customfield';
// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const $4964d6f513930168$var$mergePrefilled = (oldPayload, newPayload)=>{
    if (newPayload !== null && newPayload !== undefined) // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
    return {
        ...oldPayload,
        ...newPayload
    };
    return oldPayload;
};
const $4964d6f513930168$var$returnActualValue = (value)=>{
    if (Array.isArray(value)) return value[0].toString();
    return value.toString();
};
// @ts-expect-error - TS7023 - 'mergeFormat' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions. | TS7006 - Parameter 'format' implicitly has an 'any' type.
const $4964d6f513930168$var$mergeFormat = (format, finalKey, finalValue)=>{
    // Ideally format can be object or string
    // Format will only contain 1 object having single key/value where value can be null or an object
    // go inside and wherever we find first null, replace the same with the value.
    // some of the mutation use fieldId whereas other uses like priorityId
    // so whichever key has value === ID will replace the same with the proper mutationKey
    if (typeof format === 'string') {
        if (format === 'ID') return finalKey;
        return format;
    }
    // recursively goes inside to find the null and key param and replace with the corresponding values
    // Also checks for array like labels
    return Object.keys(format).reduce((accumulator, currentKey)=>{
        const currentValue = format[currentKey];
        if (Array.isArray(currentValue)) {
            const mappedValue = Array.isArray(finalValue) ? finalValue : [
                finalValue
            ];
            return {
                // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                ...accumulator,
                [currentKey]: mappedValue.map((val)=>$4964d6f513930168$var$mergeFormat(currentValue[0], finalKey, val))
            };
        }
        return {
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...accumulator,
            [currentKey]: currentValue === null ? $4964d6f513930168$var$returnActualValue(finalValue) : $4964d6f513930168$var$mergeFormat(format[currentKey], finalKey, finalValue)
        };
    }, {});
};
const $4964d6f513930168$var$generateDefaultValuesForEcosystemAPI = (otherFields)=>{
    const defaultValues = {};
    const fieldIds = [];
    Object.keys(otherFields).forEach((mutationKey)=>{
        const mutationValue = otherFields[mutationKey];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
        if ((0, $eGXjT.ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const mutationGroup = (0, $eGXjT.ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const formattedValue = (0, $eGXjT.ECOSYSTEM_API_FIELD_FORMATTER)[mutationGroup](mutationKey, mutationValue);
            if (formattedValue) {
                const { value: value, type: type } = formattedValue;
                fieldIds.push(mutationKey);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(value)) {
                    if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(value);
                    else if (type === 'object') defaultValues[mutationGroup] = value;
                }
            }
        }
    });
    return {
        defaultValues: defaultValues,
        fieldIds: fieldIds
    };
};
const $4964d6f513930168$var$generateDefaultValuesLegacy = (otherFields)=>{
    const defaultValues = {};
    const fieldIds = [];
    Object.keys(otherFields).forEach((mutationKey)=>{
        const mutationValue = otherFields[mutationKey];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
        if ((0, $fRoGq.FIELD_MAPPER_MUTATION_GROUP)[mutationKey]) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: "singleLineTextFields"; readonly epic: "epicLinkField"; readonly epicName: "singleLineTextFields"; readonly duedate: "datePickerFields"; readonly startdate: "datePickerFields"; ... 7 more ...; readonly components: "components"; }'.
            const mutationGroup = (0, $fRoGq.FIELD_MAPPER_MUTATION_GROUP)[mutationKey];
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly singleLineTextFields: { readonly value: { readonly fieldId: "ID"; readonly text: null; }; readonly type: "array"; }; readonly epicLinkField: { readonly value: { readonly fieldId: "ID"; readonly epicLink: { readonly issueKey: null; }; }; readonly type: "object"; }; ... 7 more ...; readonly components: { .....'.
            const { type: type = null, value: depth = null } = (0, $fRoGq.FORMATTER)[mutationGroup];
            let pattern = null;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(mutationValue) && depth && type) {
                if (!Array.isArray(mutationValue) && typeof mutationValue === 'object') {
                    const { fieldId: fieldId, fieldValue: fieldValue } = mutationValue;
                    // If fieldValue is different from the key like custom fields
                    pattern = $4964d6f513930168$var$mergeFormat(depth, fieldId || mutationKey, fieldValue);
                    fieldIds.push(fieldId || mutationKey);
                } else {
                    // same as key like summary etc.
                    pattern = $4964d6f513930168$var$mergeFormat(depth, mutationKey, mutationValue);
                    fieldIds.push(mutationKey);
                }
            }
            // merge mutations based on type as some mutations are object whereas others are arrays
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(pattern)) {
                if (type === 'array') (defaultValues[mutationGroup] = defaultValues[mutationGroup] || []).push(pattern);
                else if (type === 'object') defaultValues[mutationGroup] = pattern;
            }
        }
    });
    return {
        defaultValues: defaultValues,
        fieldIds: fieldIds
    };
};
const $4964d6f513930168$export$300f392f5922240 = (otherFields, isEcosystemAPI = false)=>{
    if (isEcosystemAPI) return $4964d6f513930168$var$generateDefaultValuesForEcosystemAPI(otherFields);
    return $4964d6f513930168$var$generateDefaultValuesLegacy(otherFields);
};
const $4964d6f513930168$export$1e69307ca1d0a0a = (trigger)=>{
    const anchor = trigger.nodeName === 'A' ? trigger : trigger.querySelector('a');
    if (anchor) {
        const href = anchor.getAttribute('href');
        // @ts-expect-error - TS2769 - No overload matches this call. | TS7006 - Parameter 'qs' implicitly has an 'any' type.
        const { query: query } = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(href, (qs)=>new URLSearchParams(qs));
        const returnData = {
            prefilledFields: {}
        };
        // If data attributes exist, we will prefer those over the query params.
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const pid = anchor.getAttribute('data-pid') || query.get('pid');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const issuetype = anchor.getAttribute('data-issue-type') || query.get('issuetype');
        // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2349 - This expression is not callable.
        const requestype = anchor.getAttribute('data-itsm-category') || query.get('itsmCategory');
        if (pid) // @ts-expect-error - TS2339 - Property 'pid' does not exist on type '{}'.
        returnData.prefilledFields.pid = pid;
        if (issuetype) // @ts-expect-error - TS2339 - Property 'issuetype' does not exist on type '{}'.
        returnData.prefilledFields.issuetype = issuetype;
        if (requestype) // @ts-expect-error - TS2339 - Property 'requestype' does not exist on type '{}'.
        returnData.prefilledFields.requestype = requestype;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(returnData.prefilledFields)) return returnData;
        return {};
    }
    return {};
};
const $4964d6f513930168$export$70cb7a42e309786 = (payload = {}, isEcosystemAPI = false)=>{
    const { prefilledFields: gicPreFilledFields, target: target = null } = payload;
    let prefilledFields = gicPreFilledFields;
    if (target) {
        const newPayload = $4964d6f513930168$export$1e69307ca1d0a0a(target);
        prefilledFields = $4964d6f513930168$var$mergePrefilled(gicPreFilledFields, newPayload.prefilledFields);
    }
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(prefilledFields)) {
        const { fieldsToRetain: fieldsToRetain = [], pid: pid, issuetype: issuetype, requestype: requestype, additionalContext: additionalContext, statusId: statusId, ...otherFields } = prefilledFields;
        const outputPayload = {};
        if ((!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(pid) || typeof pid === 'number') && pid !== 'undefined') outputPayload.project = {
            projectId: $4964d6f513930168$var$returnActualValue(pid)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(issuetype) || typeof issuetype === 'number') outputPayload.issueType = {
            issueTypeId: $4964d6f513930168$var$returnActualValue(issuetype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(requestype)) outputPayload.requestType = {
            key: $4964d6f513930168$var$returnActualValue(requestype)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(otherFields.parentId)) outputPayload.parentId = {
            parentId: $4964d6f513930168$var$returnActualValue(otherFields.parentId)
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(statusId)) outputPayload.status = {
            statusId: statusId
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(additionalContext)) outputPayload.additionalContext = additionalContext;
        // for other fields
        if (Object.keys(otherFields).length > 0) {
            const { parentId: parentId, ...otherFieldsWithoutParent } = otherFields;
            const { defaultValues: defaultValues, fieldIds: fieldIds } = $4964d6f513930168$export$300f392f5922240(parentId !== undefined && !(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(parentId) ? {
                parent: parentId,
                ...otherFieldsWithoutParent
            } : otherFieldsWithoutParent, isEcosystemAPI);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(defaultValues)) outputPayload.defaultValues = defaultValues;
            outputPayload.customFieldsToPreserveOnFormRecreation = [
                ...fieldsToRetain,
                ...fieldIds
            ];
        }
        return outputPayload;
    }
    return null;
};
const $4964d6f513930168$export$3d0318b836ef9005 = (payload = {})=>{
    // customField's id's start with the name customfield https://confluence.atlassian.com/adminjiraserver/advanced-use-of-the-jira-issue-collector-938847349.html
    const fieldsToPrefill = payload?.prefilledFields;
    if (!fieldsToPrefill) return {};
    const prefilledCustomFields = {};
    const systemFieldsToBeIncluded = [
        'worklog_timeLogged',
        'worklog_startDate',
        'worklog_comment',
        'timetracking_remainingestimate',
        'description',
        'paragraph',
        'environment'
    ];
    Object.keys(fieldsToPrefill).forEach((key)=>{
        if (key.startsWith($4964d6f513930168$var$CUSTOM_FIELD_PREFIX) || systemFieldsToBeIncluded.includes(key)) prefilledCustomFields[key] = fieldsToPrefill[key];
    });
    return prefilledCustomFields;
};
const $4964d6f513930168$export$2b461e4b4c8d36cf = (defaultValuesFromAPI = {}, defaultValuesFromFE = {})=>{
    const mergedDefaultValues = JSON.parse(JSON.stringify(defaultValuesFromAPI));
    if (!defaultValuesFromFE) return mergedDefaultValues;
    Object.keys(defaultValuesFromFE).forEach((key)=>{
        if (mergedDefaultValues?.key) mergedDefaultValues[key] = {
            ...mergedDefaultValues[key],
            ...defaultValuesFromFE[key]
        };
        else mergedDefaultValues[key] = defaultValuesFromFE[key];
    });
    return mergedDefaultValues;
};
const $4964d6f513930168$export$db3a4d24608ba186 = $4964d6f513930168$export$70cb7a42e309786;

});
parcelRegister("fRoGq", function(module, exports) {

$parcel$export(module.exports, "FORMATTER", () => $5eb972acc80e3785$export$92cfe806f4f0ae2f);
$parcel$export(module.exports, "FIELD_MAPPER_MUTATION_GROUP", () => $5eb972acc80e3785$export$6669905e89f27d17);
const $5eb972acc80e3785$export$92cfe806f4f0ae2f = {
    singleLineTextFields: {
        value: {
            fieldId: 'ID',
            text: null
        },
        type: 'array'
    },
    epicLinkField: {
        value: {
            fieldId: 'ID',
            epicLink: {
                issueKey: null
            }
        },
        type: 'object'
    },
    sprintsField: {
        value: {
            fieldId: 'ID',
            sprints: [
                {
                    sprintId: null
                }
            ]
        },
        type: 'object'
    },
    priority: {
        value: {
            priorityId: 'ID'
        },
        type: 'object'
    },
    datePickerFields: {
        value: {
            fieldId: 'ID',
            date: {
                formattedDate: null
            }
        },
        type: 'array'
    },
    dateTimePickerFields: {
        value: {
            fieldId: 'ID',
            dateTime: {
                formattedDateTime: null
            }
        },
        type: 'array'
    },
    labelsFields: {
        value: {
            fieldId: 'ID',
            labels: [
                {
                    name: null
                }
            ]
        },
        type: 'array'
    },
    singleSelectUserPickerFields: {
        value: {
            fieldId: 'ID',
            user: {
                accountId: null
            }
        },
        type: 'array'
    },
    multipleVersionPickerFields: {
        value: {
            fieldId: 'ID',
            versions: [
                {
                    versionId: null
                }
            ]
        },
        type: 'array'
    },
    components: {
        value: {
            componentId: null
        },
        type: 'array'
    },
    parentField: {
        value: {
            issueId: null
        },
        type: 'object'
    }
};
const $5eb972acc80e3785$export$6669905e89f27d17 = {
    summary: 'singleLineTextFields',
    epic: 'epicLinkField',
    epicName: 'singleLineTextFields',
    duedate: 'datePickerFields',
    startdate: 'datePickerFields',
    plannedStartDate: 'dateTimePickerFields',
    plannedEndDate: 'dateTimePickerFields',
    labels: 'labelsFields',
    sprint: 'sprintsField',
    assignee: 'singleSelectUserPickerFields',
    reporter: 'singleSelectUserPickerFields',
    fixVersions: 'multipleVersionPickerFields',
    components: 'components',
    parent: 'parentField'
};

});

parcelRegister("eGXjT", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_API_FIELD_FORMATTER", () => $a7c52695fe4779f9$export$8ef3266ee07318b4);
$parcel$export(module.exports, "ECOSYSTEM_API_FIELD_MAPPER_MUTATION_GROUP", () => $a7c52695fe4779f9$export$343b44fa14f045e3);

var $bu7JM = parcelRequire("bu7JM");
const $a7c52695fe4779f9$export$8ef3266ee07318b4 = {
    security: (id, input)=>{
        if ((0, $bu7JM.checkIfValidId)(input)) return {
            value: {
                securityLevelId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $bu7JM.checkIfValidId)(input[0])) return {
            value: {
                securityLevelId: Number(input[0])
            },
            type: 'object'
        };
    },
    singleLineTextFields: (id, input)=>{
        if (typeof input === 'string' || typeof input === 'number') return {
            value: {
                fieldId: id,
                text: input.toString()
            },
            type: 'array'
        };
        if (Array.isArray(input) && input.length > 0) return {
            value: {
                fieldId: id,
                text: input[0].toString()
            },
            type: 'array'
        };
    },
    timeTrackingField: (id, input)=>{
        if (typeof input === 'string') return {
            value: {
                originalEstimate: input
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') return {
            value: {
                originalEstimate: input[0]
            },
            type: 'object'
        };
    },
    priority: (id, input)=>{
        if ((0, $bu7JM.checkIfValidId)(input)) return {
            value: {
                priorityId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $bu7JM.checkIfValidId)(input[0])) return {
            value: {
                priorityId: Number(input[0])
            },
            type: 'object'
        };
    },
    resolution: (id, input)=>{
        if ((0, $bu7JM.checkIfValidId)(input)) return {
            value: {
                resolutionId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $bu7JM.checkIfValidId)(input[0])) return {
            value: {
                resolutionId: Number(input[0])
            },
            type: 'object'
        };
        return {
            value: {
                resolutionId: 10000
            },
            type: 'object'
        };
    },
    datePickerFields: (id, input)=>{
        if (typeof input === 'string') {
            const dateInISO = (0, $bu7JM.findADate)(input);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    date: {
                        formattedDate: dateInISO
                    }
                },
                type: 'array'
            };
        }
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') {
            const dateInISO = (0, $bu7JM.findADate)(input[0]);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    date: {
                        formattedDate: dateInISO
                    }
                },
                type: 'array'
            };
        }
    },
    dateTimePickerFields: (id, input)=>{
        if (typeof input === 'string') {
            const dateInISO = (0, $bu7JM.findADate)(input);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    dateTime: {
                        formattedDateTime: dateInISO
                    }
                },
                type: 'array'
            };
        }
        if (Array.isArray(input) && input.length > 0 && typeof input[0] === 'string') {
            const dateInISO = (0, $bu7JM.findADate)(input[0]);
            if (dateInISO) return {
                value: {
                    fieldId: id,
                    dateTime: {
                        formattedDateTime: dateInISO
                    }
                },
                type: 'array'
            };
        }
    },
    labelsFields: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const label of input)if (typeof label === 'string' || typeof label === 'number') transformedValue.push({
                name: label.toString()
            });
        } else if (typeof input === 'string' || typeof input === 'number') transformedValue = [
            {
                name: input.toString()
            }
        ];
        return {
            value: {
                fieldId: id,
                labels: transformedValue
            },
            type: 'array'
        };
    },
    multipleVersionPickerFields: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const version of input)if ((0, $bu7JM.checkIfValidId)(version)) transformedValue.push({
                versionId: Number(version)
            });
        } else if ((0, $bu7JM.checkIfValidId)(input)) transformedValue = [
            {
                versionId: Number(input)
            }
        ];
        return {
            value: {
                fieldId: id,
                versions: transformedValue
            },
            type: 'array'
        };
    },
    components: (id, input)=>{
        let transformedValue = [];
        if (Array.isArray(input) && input.length > 0) {
            for (const component of input)if ((0, $bu7JM.checkIfValidId)(component)) transformedValue.push({
                componentId: Number(component)
            });
        } else if ((0, $bu7JM.checkIfValidId)(input)) transformedValue = [
            {
                componentId: Number(input)
            }
        ];
        return {
            value: transformedValue,
            type: 'object'
        };
    },
    parentField: (id, input)=>{
        if ((0, $bu7JM.checkIfValidId)(input)) return {
            value: {
                issueId: Number(input)
            },
            type: 'object'
        };
        if (Array.isArray(input) && input.length > 0 && (0, $bu7JM.checkIfValidId)(input[0])) return {
            value: {
                issueId: Number(input[0])
            },
            type: 'object'
        };
    }
};
const $a7c52695fe4779f9$export$343b44fa14f045e3 = {
    security: 'security',
    resolution: 'resolution',
    summary: 'singleLineTextFields',
    epicName: 'singleLineTextFields',
    duedate: 'datePickerFields',
    startdate: 'datePickerFields',
    labels: 'labelsFields',
    fixVersions: 'multipleVersionPickerFields',
    versions: 'multipleVersionPickerFields',
    components: 'components',
    parent: 'parentField',
    priority: 'priority',
    timetracking_originalestimate: 'timeTrackingField'
};

});
parcelRegister("bu7JM", function(module, exports) {

$parcel$export(module.exports, "findADate", () => $c1ccc19d7bfcb257$export$3ce9cccf56f196eb);
$parcel$export(module.exports, "checkIfValidId", () => $c1ccc19d7bfcb257$export$d65005e77da517bc);
const $c1ccc19d7bfcb257$var$monthMap = {
    Jan: '01',
    January: '01',
    Feb: '02',
    February: '02',
    Mar: '03',
    March: '03',
    Apr: '04',
    April: '04',
    May: '05',
    Jun: '06',
    June: '06',
    Jul: '07',
    July: '07',
    Aug: '08',
    August: '08',
    Sep: '09',
    September: '09',
    Oct: '10',
    October: '10',
    Nov: '11',
    November: '11',
    Dec: '12',
    December: '12'
};
const $c1ccc19d7bfcb257$var$formatDay = (day)=>{
    if (day.length === 1) return `0${day}`;
    return day;
};
const $c1ccc19d7bfcb257$var$formatMonth = (month)=>{
    if ($c1ccc19d7bfcb257$var$monthMap[month]) return $c1ccc19d7bfcb257$var$monthMap[month];
    if (month.length === 1) return `0${month}`;
    return month;
};
const $c1ccc19d7bfcb257$var$formatYear = (year)=>{
    const yearAsNumber = Number(year);
    if (yearAsNumber < 100) return yearAsNumber + 2000;
    return yearAsNumber;
};
const $c1ccc19d7bfcb257$var$constructISOTime = (time)=>{
    const timeStr = time.trim();
    const time24HourPattern = /^T(\d{1,2}):(\d{2}):?(\d{2})?$/;
    const time12HourPattern = /^@?\s*(\d{1,2}):(\d{2})\s*(am|pm)?$/i;
    const match24Hour = timeStr.match(time24HourPattern);
    if (match24Hour) {
        // eslint-disable-next-line prefer-const
        let [, hours, minutes, seconds] = match24Hour;
        seconds = seconds || '00';
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
    }
    const match12Hour = timeStr.match(time12HourPattern);
    if (match12Hour) {
        let hours;
        let minutes;
        let ampm;
        [, hours, minutes, ampm] = match12Hour;
        hours = parseInt(hours, 10);
        minutes = parseInt(minutes, 10);
        if (ampm) {
            ampm = ampm.toLowerCase();
            if (ampm === 'pm' && hours !== 12) hours += 12;
            else if (ampm === 'am' && hours === 12) hours = 0;
        }
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
    }
    return '00:00:00';
};
const $c1ccc19d7bfcb257$var$constructISODateTime = (date)=>{
    const regexForDay = /^(\d{1,2})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{2,4})(.*)/;
    const regexForDateWithYYYYFirst = /^(\d{2,4})[/\s-]([A-Za-z]+|\d{1,2})[/\s-](\d{1,2})(.*)/;
    const matchForDay = date.match(regexForDay);
    const matchForDayWithYYYYFirst = date.match(regexForDateWithYYYYFirst);
    if (matchForDay) {
        const [, day, month, year, time] = matchForDay;
        let formattedDay = $c1ccc19d7bfcb257$var$formatDay(day);
        let formattedMonth = $c1ccc19d7bfcb257$var$formatMonth(month);
        const formattedYear = $c1ccc19d7bfcb257$var$formatYear(year);
        let skipMatchingDay = false;
        if (Number(day) < 13 && Number(month)) [formattedDay, formattedMonth] = [
            formattedMonth,
            formattedDay
        ];
        else if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else skipMatchingDay = true;
        }
        if (!skipMatchingDay) {
            const isoTime = $c1ccc19d7bfcb257$var$constructISOTime(time);
            return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
        }
    }
    if (matchForDayWithYYYYFirst) {
        const [, year, month, day, time] = matchForDayWithYYYYFirst;
        let formattedDay = $c1ccc19d7bfcb257$var$formatDay(day);
        let formattedMonth = $c1ccc19d7bfcb257$var$formatMonth(month);
        const formattedYear = $c1ccc19d7bfcb257$var$formatYear(year);
        if (Number(formattedMonth) > 12) {
            if (Number(formattedDay) < 13) [formattedDay, formattedMonth] = [
                formattedMonth,
                formattedDay
            ];
            else return null;
        }
        const isoTime = $c1ccc19d7bfcb257$var$constructISOTime(time);
        return `${formattedYear}-${formattedMonth}-${formattedDay}T${isoTime}`;
    }
    return null;
};
function $c1ccc19d7bfcb257$var$convertUnixToISO(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);
    if (!date.getTime()) return null;
    return date.toISOString().slice(0, 19);
}
const $c1ccc19d7bfcb257$export$3ce9cccf56f196eb = (defaultValue)=>{
    if (typeof defaultValue === 'number') return $c1ccc19d7bfcb257$var$convertUnixToISO(defaultValue);
    if (typeof defaultValue === 'string') {
        if (Number(defaultValue)) return $c1ccc19d7bfcb257$var$convertUnixToISO(Number(defaultValue));
        return $c1ccc19d7bfcb257$var$constructISODateTime(defaultValue);
    }
    return null;
};
const $c1ccc19d7bfcb257$export$d65005e77da517bc = (input)=>{
    if ((typeof input === 'string' || typeof input === 'number') && Number(input)) return true;
    return false;
};

});



parcelRegister("jHGDp", function(module, exports) {

$parcel$export(module.exports, "modernIssueCreateInGenericFunctions", () => $338619a372b35ad8$export$ab5024c1d22c7420);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $338619a372b35ad8$export$ab5024c1d22c7420 = (params)=>{
    const fields = params?.fields;
    const title = params?.title;
    const callback = params?.callback;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.dispatchEvent(new CustomEvent('openIssueCreateDialog', {
        detail: {
            payload: {
                triggerPointKeySuffix: 'generic',
                isPrefillingAllowed: true,
                callback: callback,
                title: title,
                prefilledFields: fields ? {
                    pid: fields?.pid,
                    issuetype: fields?.issueType,
                    ...fields?.fields
                } : {}
            }
        }
    }));
};

});



//# sourceMappingURL=async-new-issue-create-trigger.ff52e2be.js.map
